import React from 'react';
import styled from 'styled-components';
import Grid from '../components/Grid';
import Theme from '../Theme';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useInView } from 'react-intersection-observer';
import { useGlobalState } from '../scripts/useGlobalState';
import useWindowDimensions from '../scripts/useWindowDimensions';

const Video = styled.video`
    grid-column: 1 / -1;
    width: 100%;
    height: 100vh;
    object-fit: cover;
    ${Theme.breakpoint('md')`
    `}
    ${Theme.breakpoint('lg')`
    `}
`
const Source = styled.source`
`

const Track = styled.track`

`
const Wrapper = styled.div`
    background-color: #EFEFEF;
`
const CustomGrid = styled.div`
  background: ${Theme.colors.black};
  min-height: 100vh;
  ${Theme.breakpoint('lg')`
      padding: 0;
      max-width: 1512px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(12, 1fr);
  `}
`
gsap.registerPlugin(ScrollTrigger);
export default function Process({assets}) {
  const [screenSize, setScreenSize] = React.useState();
  // const { container, inView, entry } = useInView({});
  const videoRef = React.useRef(null)
  const IntroVideoRef = React.useRef(null);
  const [pageLoading, setPageLoading] = useGlobalState('loading')
  const { width, height } = useWindowDimensions();
  const [source, setSource] = React.useState('');
  const [rendering, setRendering] = useGlobalState('rendering');
  let scrollPos, videoDuration, videoCurrentTime;


  React.useEffect(() => {
    videoRef.current.currentTime = 0;
    !pageLoading && ScrollTrigger.create({
      trigger: IntroVideoRef.current,
      scrub: true,
      pin: IntroVideoRef.current,
      start: 'center center',
      end: '+=6000',
      // markers: true,
      
      onUpdate: function (e) {
        if (videoRef.current) {
          scrollPos = e.progress;
          videoDuration = videoRef.current.duration;
          videoCurrentTime = videoDuration * scrollPos;
          if (videoCurrentTime) {
            videoRef.current.currentTime = videoCurrentTime;
          }
          console.log(videoDuration, scrollPos, videoCurrentTime)
        }
      },
    })
    // videoRef.current.play();
    // videoRef.current.pause();
  }, [IntroVideoRef, videoRef, pageLoading])


  React.useEffect(() => {
    if (width <= 768) {
      setSource(assets[0]);
    } else if (width <= 1024) {
      setSource(assets[2]);
    }
    else {
      setSource(assets[1]);
    }
  }, [width, assets]);

  React.useEffect(() => !pageLoading && ScrollTrigger.refresh(),[pageLoading])
  return (
    <Wrapper>
      <CustomGrid ref={IntroVideoRef}>
        <Video ref={videoRef} src={source} disablePictureInPicture={true} mute={true} autoPlay={(width <= 768) && true} playsInline ></Video>
      </CustomGrid>
    </Wrapper>
  )
}
// style={{position: 'fixed', top: '50%',left: '50%', minWidth: '100%',minHeight: '100%', transform: 'translate(-50%, -50%)'}}